import { useAsyncData, useRoute } from '#imports'

import type { ArticleCard } from '@backmarket/nuxt-layer-cms/ArticleCard/ArticleCard.types'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import { useMasterPP } from '~/scopes/product-core/composables/useMasterPP/useMasterPP'

export async function useArticles(sourceUrl: string) {
  const $httpFetch = useHttpFetch()

  const route = useRoute()
  const { isMasterPPUrl } = useMasterPP()

  return useAsyncData(
    () => {
      return $httpFetch('/internal-links/v1/cards', {
        query: {
          source_url: isMasterPPUrl.value ? sourceUrl : route.fullPath,
        },
        timeout: 500,
      })
    },
    {
      default() {
        return []
      },
      transform(data): ArticleCard[] {
        const filteredLinkList = data?.linkLists.find(
          (linkList) => linkList.listId === 'pp_cards',
        )

        return (filteredLinkList?.links || [])
          .map((item) => ({
            title: item.title,
            text: item.description,
            id: item.link.href,
            imageSrc: item.image.src,
            link: { href: item.link.relativeHref },
            category: item.tagline,
            ...(item.image.alt ? { imageAlt: item.image.alt } : {}),
          }))
          .filter(
            (item): item is ArticleCard =>
              item.imageSrc !== null &&
              item.title !== null &&
              item.text !== null &&
              item.imageAlt !== null,
          )
      },
    },
  )
}
